import { Simple as Media } from './Simple';
import SmartMedia from './SmartMedia';
import IntroMedia from './IntroMedia';

export { Media, SmartMedia, IntroMedia };
export default Media;
